import {
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsString,
  MinLength,
  Matches,
} from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { MulterFile } from '@webundsoehne/nest-fastify-file-upload';
import { Type } from 'class-transformer';
import { JSONToClass } from '@/common/validators/json-to-class.decorator';

class SignupProgramItemDto {
  @ApiProperty({ example: 1, description: 'Program ID' })
  @Type(() => Number)
  program_id!: number;

  @ApiProperty({ example: 2, description: 'Program type ID' })
  @Type(() => Number)
  type_id!: number;
}

export class SignupDto {
  @ApiProperty({ example: 'John Doe' })
  @IsNotEmpty()
  @IsString()
  name: string;

  @ApiProperty({ example: 'john@example.com' })
  @IsEmail()
  @IsNotEmpty()
  email: string;

  @ApiProperty({ example: '+1234567890', required: false })
  @IsOptional()
  @IsString()
  phone?: string;

  @ApiProperty({ example: 'Password123!', minLength: 8 })
  @IsNotEmpty()
  @IsString()
  @MinLength(8)
  @Matches(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, {
    message:
      'Password must contain uppercase, lowercase, number or special character',
  })
  password: string;

  @ApiProperty({
    type: String,
    format: 'binary',
    required: false,
    description: 'Profile image URL',
  })
  image_url?: MulterFile;

  @ApiProperty({
    type: String,
    required: false,
    description:
      'List of programs with associated type IDs (send as JSON string in multipart) ',
    example: '[{"program_id":1,"type_id":2}]',
  })
  @IsOptional()
  // @ValidateNested({ each: true })
  @JSONToClass(SignupProgramItemDto)
  programs?: SignupProgramItemDto[];

  @ApiProperty({
    type: String,
    required: false,
    description:
      'List of category IDs (JSON string like "[1,2]" or CSV like "1,2,3")',
    example: '[1,2]',
  })
  @IsOptional()
  @JSONToClass(Number)
  category_ids?: number[];
}
